import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isLoading: false,
    ictDetailsInventoryData: {},
    ictDetailsInventoryResponse: {},
    ictInitialInventoryPartialAnswersData: {},
    ictEvaluationDetailsData: {},
    ictEvaluationPartialAnswersData: {},
    ictEvaluationResponseData: {},
    ictEvaluationConfirmData: {},
    ictFollowupDetailsData: {},
    ictFollowupPartialAnswersData: {},
    ictFollowupResponseData: {},
    errors:[]
};

export const ictDetailsSlice = createSlice({
  name: "ictDetails",
  initialState,
  reducers: {
    clearIctDetailsData: () => initialState,
    // initial inventory data
    setIctDetailsLoading: (state, action) => {
      state.isLoading = true;
    },
    setIctInventoryData: (state, action) => {
      state.isLoading = false;
      state.ictDetailsInventoryData = action.payload;
    },
    setIctInventoryResponseData: (state, action) => {
      state.isLoading = false;
      state.ictDetailsInventoryResponse = action.payload;
    },
    setIctInventoryPartialAnswersData: (state, action) => {
      state.isLoading = false;
      state.ictInitialInventoryPartialAnswersData = action.payload;
    },
    setIctEvaluationData: (state, action) => {
      state.isLoading = false;
      state.ictEvaluationDetailsData = action.payload;
    },
    setIctEvaluationPartialAnswersData: (state, action) => {
      state.isLoading = false;
      state.ictEvaluationPartialAnswersData = action.payload;
    },
    setIctEvaluationResponseData: (state, action) => {
      state.isLoading = false;
      state.ictEvaluationResponseData = action.payload;
    },
    setIctEvaluationConfirmData: (state, action) => {
      state.isLoading = false;
      state.ictEvaluationConfirmData = action.payload;
    },
    setIctFollowupDetailsData: (state, action) => {
      state.isLoading = false;
      state.ictFollowupDetailsData = action.payload;
    },
    setIctFollowupPartialAnswersData: (state, action) => {
      state.isLoading = false;
      state.ictFollowupPartialAnswersData = action.payload;
    },
    setIctFollowupResponseData: (state, action) => {
      state.isLoading = false;
      state.ictFollowupResponseData = action.payload;
    },
    setIctDetailsError: (state, action) => {
        state.isLoading = false;
        state.errors = action.payload;
      },
    clearIctDetailsError: (state) => {
      state.isLoading = false;
      state.errors = [];
    },
  },
});

export const { 
    setIctInventoryData, 
    setIctInventoryResponseData, 
    setIctInventoryPartialAnswersData,
    setIctDetailsLoading, 
    clearIctDetailsData,
    setIctEvaluationData,
    setIctEvaluationPartialAnswersData,
    setIctEvaluationResponseData,
    setIctEvaluationConfirmData,
    setIctFollowupDetailsData,
    setIctFollowupPartialAnswersData,
    setIctFollowupResponseData,
    setIctDetailsError,
    clearIctDetailsError,
    } = ictDetailsSlice.actions;

export default ictDetailsSlice.reducer;